'use strict'

import axios from 'axios'

const { VUE_APP_ORDERS_URL } = process.env

export default async receiptId => axios({
  method: 'GET',
  headers: {
    Authorization: sessionStorage.getItem('jwt')
  },
  url: `${VUE_APP_ORDERS_URL}/receipt/${receiptId}`,
  timeout: 8000
})
